var _excluded = ["children", "width", "align"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import hyper from "@macrostrat/hyper";
import { Alignment } from "@blueprintjs/core";
import styles from "./docs.module.styl";
import { useInView } from "react-intersection-observer";
import { HashLink } from "react-router-hash-link";
import { routerBasename } from "../settings";
import classNames from "classnames";
import { joinURL } from "~/map-interface/utils";
var h = hyper.styled(styles);
var urlBase = "https://macrostrat-media.s3.amazonaws.com/maps/docs/";

function DocsMediaFile(_ref) {
  var href = _ref.href,
      _ref$lazy = _ref.lazy,
      lazy = _ref$lazy === void 0 ? true : _ref$lazy,
      className = _ref.className;

  var _useInView = useInView({
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  var src = null;

  if (inView || !lazy) {
    src = joinURL(urlBase, href);
  }

  if (href.endsWith(".mp4")) {
    return h("video", {
      ref: ref,
      autoPlay: true,
      loop: true,
      playsInline: true,
      muted: true,
      type: "video/mp4",
      src: src,
      className: className
    });
  }

  return h("img", {
    ref: ref,
    src: src,
    className: className
  });
}

export function DocsMedia(_ref2) {
  var children = _ref2.children,
      width = _ref2.width,
      _ref2$align = _ref2.align,
      align = _ref2$align === void 0 ? Alignment.RIGHT : _ref2$align,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var className = classNames(align, {
    captioned: children != null
  });
  return h("figure.documentation-figure", {
    style: {
      width: width
    },
    className: className
  }, [h(DocsMediaFile, rest), h["if"](children != null)("figcaption.caption", children)]);
}
export function DocsVideo(_ref3) {
  var slug = _ref3.slug,
      _ref3$lazy = _ref3.lazy,
      lazy = _ref3$lazy === void 0 ? true : _ref3$lazy,
      className = _ref3.className;
  // For legacy reasons, the alignment is set to left
  return h(DocsMedia, {
    href: slug + ".mp4",
    lazy: lazy,
    className: className,
    align: Alignment.LEFT
  });
}
export function InternalLink(_ref4) {
  var to = _ref4.to,
      children = _ref4.children;
  // We'd use a link component, but it doesn't properly navigate to the hash state
  return h("a.internal-link", {
    href: joinURL(routerBasename, to)
  }, children);
}
export function NewSwatch(_ref5) {
  var children = _ref5.children,
      _ref5$version = _ref5.version,
      version = _ref5$version === void 0 ? 0 : _ref5$version;
  return h(HashLink, {
    to: routerBasename + "changelog#version-".concat(version),
    className: "new-swatch"
  }, children);
}
export function Version(_ref6) {
  var spec = _ref6.spec,
      date = _ref6.date,
      _ref6$major = _ref6.major,
      major = _ref6$major === void 0 ? true : _ref6$major;
  return h("h".concat(major ? 2 : 3, ".version"), {
    id: "version-".concat(spec)
  }, [h("span.version-name", ["Version ", h("code", spec)]), h("span.date", date)]);
}